/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiology-report.reducer';

export const RadiologyReportDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiologyReportEntity = useAppSelector(state => state.radiologyReport.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiologyReportDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiologyReport.detail.title">RadiologyReport</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.id}</dd>
          <dt>
            <span id="reportStatus">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.reportStatus">Report Status</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.reportStatus}</dd>
          <dt>
            <span id="reportDate">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.reportDate">Report Date</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.reportDate}</dd>
          <dt>
            <span id="reportBody">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.reportBody">Report Body</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.reportBody}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateVoided">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.dateVoided">Date Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.dateVoided}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiologyReport.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiologyReportEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReport.reporter">Reporter</Translate>
          </dt>
          <dd>{radiologyReportEntity.reporter ? radiologyReportEntity.reporter.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReport.patient">Patient</Translate>
          </dt>
          <dd>{radiologyReportEntity.patient ? radiologyReportEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReport.study">Study</Translate>
          </dt>
          <dd>{radiologyReportEntity.study ? radiologyReportEntity.study.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiology-report" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiology-report/${radiologyReportEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiologyReportDetail;
